"use client";

import { useEffect, useState } from "react";

/**
 * Returns `value` delayed by `delayMs`. Updates are cancelled if `value`
 * changes again before the delay elapses.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
